import Swal from "sweetalert2"

import PropTypes from "prop-types";
const handleCustomerResponse = (response, action,props)=>{
    let successMessage
    let errorMessage
    switch(action){
        case 'create': 
            successMessage = 'Representante registrado exitosamente'
            errorMessage = 'Representante no registrado'
            break;
        case 'update':
            successMessage = 'Representante actualizado exitosamente'
            errorMessage = 'Representante no actualizado'
            break;
        default:
            break;
    }
      if(response.length > 1){
              Swal.fire({
                icon: 'error',
                title: errorMessage,
                html:`${response}`,
                showConfirmButton: true,
                confirmButtonText: 'Aceptar'
              });
      
            } else{
              Swal.fire({
                icon: 'success',
                title: successMessage,
                showConfirmButton: true,
                confirmButtonText: 'Regresar'
              })
              .then(() => {
                props.history.push('/administration/users');
                window.location.reload();
              }); 
            }
}

export default handleCustomerResponse;
handleCustomerResponse.propTypes = {
    response: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
    action: PropTypes.oneOf(['create', 'update']).isRequired,
    props: PropTypes.shape({
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
        }).isRequired,
    }).isRequired,
};